export const GENERIC_ERROR_TEXT =
  'An error occurred. Data may be absent or incomplete.'
export const NO_DATA_TEXT = 'No data is available within the selected period.'
export const VIEW_AVAILABLE_DATA_TEXT = 'View available data'
export const LAST_DATA_SYNC = 'Latest upload'
export const VIEW_LAST_DATA_SYNC = 'View last data sync'
export const NUMBER_DAYS_WITH_DATA = 'Number of days with data'
export const MIN = 'Min'
export const MAX = 'Max'
